<ng-component></ng-component>
<ng-content></ng-content>

<app-component-modal></app-component-modal>
<app-component-mobile-popup></app-component-mobile-popup>

<app-component-file-queue *ngIf="appInitiated"></app-component-file-queue>

<app-component-alert></app-component-alert>

<app-toast-notify></app-toast-notify>